import * as React from "react";
import "./input.scss";
import {isNullOrUndefined} from "util";
import {isPhoneScreen} from "../../../../utils/Utils";

interface IProps {
	/**
	 * Input id used by an associated label.
	 */
	id?: string;
	/**
	 * Input field type attribute.
	 */
	type: "password" | "text" | "number" | "email";
	/**
	 * Input value.
	 */
	value: string | number;
	/**
	 * Placeholder string.
	 */
	placeholder?: string;
	/**
	 * Indicates if field has focus.
	 */
	focus?: boolean;
	/**
	 * Indicates if field is disabled.
	 */
	disabled?: boolean;
	/**
	 * Indicates if input field is readonly.
	 */
	readonly?: boolean;
	/**
	 * Input field on blur callback.
	 */
	onBlur?: (evt: React.FocusEvent<HTMLInputElement>) => void;
	/**
	 * On input focus callback.
	 */
	onFocus?: (evt: React.FocusEvent<HTMLInputElement>) => void;
	/**
	 * Input click callback
	 */
	onClick?: (evt: React.MouseEvent<HTMLInputElement>) => void;
	/**
	 * Input on change callback.
	 */
	onChange?: (evt: React.ChangeEvent<HTMLInputElement>) => void;
	/**
	 * On pressed 'enter' button.
	 */
	onConfirm?: (evt: React.KeyboardEvent<HTMLInputElement>) => void;
}

export default class Input extends React.Component<IProps, {}> {

	inputRef: HTMLInputElement;

	constructor(props: IProps) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
	}

	componentDidUpdate(prevProps: IProps) {
		if (prevProps.focus === false && this.props.focus === true) {
			this.inputRef.focus();
		}
	}

	componentDidMount(): void {
		if (this.props.focus && !isPhoneScreen()) {
			this.inputRef.focus();
			this.inputRef.setSelectionRange(this.inputRef.value.length, this.inputRef.value.length);
		}
	}

	render() {

		const styleFromProps = this.props.disabled ? {cursor: "not-allowed"} : {};

		return (
			<input ref={(input) => this.inputRef = input}
				   id={this.props.id}
				   className={"a-input"}
				   style={styleFromProps}
				   onKeyDown={this.onKeyDown}
				   onChange={this.onChange}
				   value={this.props.value}
				   type={this.props.type}
				   onFocus={this.props.onFocus}
				   onBlur={this.props.onBlur}
				   onClick={this.props.onClick}
				   placeholder={this.props.placeholder}
				   disabled={this.props.disabled}
				   readOnly={this.props.readonly}/>
		);
	}

	/**
	 * On input change.
	 * @param {React.ChangeEvent<HTMLInputElement>} event Input event.
	 */
	private onChange(event: React.ChangeEvent<HTMLInputElement>) {
		if (!this.props.disabled && !this.props.readonly) {
			this.props.onChange(event);
		}
	}

	/**
	 * On pressed 'enter' key.
	 * @param {React.KeyboardEvent<HTMLInputElement>} event
	 */
	private onKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
		if (event.key === "Enter" && !isNullOrUndefined(this.props.onConfirm)) {
			this.props.onConfirm(event);
		}
	}

	setFocus() {
		if (this.inputRef)
			this.inputRef.focus();
	}
}
